import React from 'react';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';

type Props = {
  isRead: boolean;
  isSent: boolean;
};

const ReadTicks = ({ isRead, isSent }: Props) => {
  return (
    <div style={{ position: 'absolute', bottom: '-15px', right: '-5px' }}>
      {isRead ? <DoneAllIcon /> : <DoneIcon />}
    </div>
  );
};

export default ReadTicks;
